<script lang="ts">
  import Chart from "chart.js";
  import { hexToRGB } from "@cohesionib/biblioteca/lib/HexTheme";

  import type { ChartData } from "./types";

  export let data: ChartData;
  export let includeTotalInTooltipTitle: boolean = false;
  export let titleTotalUnitLabel: string = "";

  const hexToRGBA = (hex: string, opacity: number) => {
    const { r, g, b } = hexToRGB(hex);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  // const baseColors = [
  //   "#15707A",
  //   "#FE4839",
  //   "#14a2CD",
  //   "#FEB560",
  //   "#07A685",
  //   "#9E1E63",
  //   "#EFCB06",
  //   "#9CD1B3",
  //   "#36F3BC",
  //   "#C71f1e",
  //   "#fe8902",
  //   "#1f80a2",
  // ];
  const baseColors = [
    "#1F78B4",
    "#74DCF1",
    "#022C64",
    "#68A9FD",
    "#3E8E41",
    "#94D197",
  ];
  const backgroundColors = baseColors.map((h) => hexToRGBA(h, 1));
  const hoverBackgroundColors = baseColors.map((h) => hexToRGBA(h, 0.98));
  const borderColors = baseColors.map((h) => hexToRGBA(h, 0.98));

  const parentBarKeys = data[0].data.map((d) => d.parentBarKey);

  const datasets = data.map((childBar, idx) => ({
    label: childBar.childBarKey,
    data: childBar.data.map((d) => ({
      y: d.parentBarKey,
      x: d.childBarValue,
    })),
    backgroundColor: backgroundColors[idx],
    hoverBackgroundColor: hoverBackgroundColors[idx],
    borderColor: borderColors[idx],
    borderWidth: 1.5,
  }));

  const parentTotals = parentBarKeys.map((name) => ({
    name,
    value: data.reduce(
      (prev, curr) =>
        curr.data.filter((r) => r.parentBarKey === name)[0].childBarValue +
        prev,
      0
    ),
  }));

  const parentOrder = parentTotals.sort((prev, curr) =>
    prev.value > curr.value ? -1 : 1
  );

  const sortedDatasets = datasets.map((d) => ({
    ...d,
    data: parentOrder.map(
      (t) => d.data.find((d) => d.y === t.name) || { x: 0, y: "" }
    ),
  }));

  const toolTipConfig: Chart.ChartTooltipCallback = {
    title: ([toolTipItem]) =>
      `${toolTipItem.label} (${
        parentTotals.find((t) => t.name === toolTipItem.label)?.value || 0
      } ${titleTotalUnitLabel})`,
  };

  const initGraph = (element: HTMLCanvasElement) => {
    new Chart(element, {
      type: "horizontalBar",
      options: {
        tooltips: {
          callbacks: includeTotalInTooltipTitle ? toolTipConfig : undefined,
        },
        animation: {
          duration: 600,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              stacked: true,
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              stacked: true,
            },
          ],
        },
      },
      data: {
        labels: parentOrder.map((t) => t.name),
        datasets: sortedDatasets,
      },
    });
  };
</script>

<style>
  #chart-container {
    width: 100%;
    height: 35em;
    display: flex;
    justify-content: center;
    align-items: center;
    height: min-content;
  }
  #chart-wrapper {
    height: 100%;
    max-width: 98em;
    min-width: 20em;
    width: 100%;
  }
  #graph-content-wrapper {
    padding: 1.5em 2em 1.5em 2em;
  }
</style>

<div id="graph-content-wrapper">
  <div id="chart-container">
    <div id="chart-wrapper"><canvas id="line-graph" use:initGraph /></div>
  </div>
</div>
